import React from 'react'
import cn from 'classnames'
import { IconCheck } from '@paro.io/base-icons'

interface CheckboxProps {
  id: string
  label?: any
  name?: string
  description?: string
  value?: any
  isChecked?: boolean
  isDisabled?: boolean
  isInvalid?: boolean
  indeterminate?: boolean // TODO
  className?: string
  onChange?: (e: any) => void
  invalidLabel?: string
}

export const Checkbox = ({
  label,
  id,
  name,
  description,
  value,
  isChecked,
  isDisabled,
  isInvalid,
  className,
  onChange,
  invalidLabel
}: CheckboxProps) => {
  return (
    <div className={cn('relative flex items-start', className)}>
      <div className='flex items-center h-5 relative'>
        <input
          id={id}
          aria-describedby={`description-for-${id}`}
          name={name}
          type='checkbox'
          className='h-5 w-5 focus-visible:ring-2 focus-visible:ring-primary'
          checked={isChecked}
          onChange={onChange}
          disabled={isDisabled}
          value={value}
        />
        <label
          htmlFor={id}
          className={cn(
            'w-5 h-5 cursor-pointer inline-block rounded-sm border 0 -ml-5',
            { 'bg-gray-100 border-gray-30': !isChecked && !isDisabled },
            { 'bg-primary border border-primary': isChecked && !isDisabled },
            { 'cursor-not-allowed': isDisabled },
            { 'bg-gray-300 border-gray-300': isDisabled && isChecked },
            { 'bg-gray-50 border-gray-100': isDisabled && !isChecked },
            { 'border-2 border-danger': isInvalid }
          )}
        >
          {isChecked ? (
            <IconCheck size='sm' className='text-white -mt-px -ml-px' />
          ) : (
            ''
          )}
        </label>
      </div>
      <div className='-mt-0.5'>
        {label ? (
          <label htmlFor={id} className='text-base pl-4'>
            {' '}
            {label}{' '}
          </label>
        ) : (
          ''
        )}
        {description ? (
          <p className='text-sm pl-4' id={`description-for-${id}`}>
            {' '}
            {description}{' '}
          </p>
        ) : (
          ''
        )}
        {isInvalid ? (
          <p className='text-xs text-danger-dark pl-4'> {invalidLabel} </p>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}
